module.exports = __webpack_public_path__ + "static/media/login.a801daf7.jpg";